<form #form="ngForm" class="campanha-item-form" novalidate>
    <div class="card">
        <div class="card-header">
            <h6 class="card-title">
                Itens
            </h6>
            <p class="form-text text-muted">
                Itens em que esta campanha é promovida
            </p>
        </div>  
        
        <div class="alert alert-info" style="margin: 0px;text-align: center;font-weight: 600;border-top-right-radius: 0px;border-top-left-radius: 0px;">
            <h5 style="font-weight: 600;">
                <i class="fas fa-hourglass-half"></i> Em Breve!
            </h5>
            <p class="m-0">Funcionalidade em desenvolvimento</p>
        </div>        
    </div>
</form>
